import { useContext } from 'react'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import theme from 'styles/theme'
import { transformHoursToTwoDigitsString } from 'utils/dates'

import { HourStyleProps } from './styles'
import { startOfHour } from 'date-fns'

export const getTextColor = ({ isSelected, isDisabled }: HourStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.white')
  }

  if (isDisabled) {
    return theme.token.var('colors.gray.300')
  }

  return theme.token.var('colors.initial')
}

export const getBackground = ({ isSelected, isDisabled }: HourStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.green.a200')
  }

  if (isDisabled) {
    return theme.token.var('colors.green.a50')
  }

  return theme.token.var('colors.green.a100')
}

export const useAllTimeHelpers = (
  index: number,
): { hour: string; buttonText: string; isSelected: boolean; isDisabled: boolean } => {
  const { dateTimeState } = useContext(DateTimePickerContext)

  const {
    props: { shouldDisableHour, isPickup },
    value,
    isProlongation,
  } = dateTimeState

  const hour = transformHoursToTwoDigitsString(index)
  const isSelected = hour === dateTimeState.value.time

  const currentDay = getCurrentDay(index, value)

  const now = startOfHour(new Date())

  let buttonText = `${hour}:00`
  if (isPickup && !isProlongation && currentDay.getDate() === now.getDate()) {
    if (index === now.getHours()) {
      buttonText = 'Now*'
    }

    if (index === now.getHours() + 1) {
      buttonText += '*'
    }
  }

  return {
    hour,
    buttonText,
    isSelected,
    isDisabled: shouldDisableHour ? shouldDisableHour(hour, currentDay) : false,
  }
}

const getCurrentDay = (
  index: number,
  value: Partial<{
    day: number
    month: number
    year: number
    time: string
  }>,
): Date => {
  if (value.year !== undefined && value.month !== undefined && value.day !== undefined) {
    return new Date(value.year, value.month, value.day, index)
  }
  return new Date()
}
